import { MutationOptions } from 'react-query';
import {
  updateOrder,
  updateOrderShowDeltaT,
  updateOrderStatus,
} from './orders.api';
import {
  OrderUpdate,
  UpdateOrderResponse,
  UpdateShowDeltaTResponse,
} from './orders.schema';
import { ExitStatusResponse } from '../../schemas/ExitStatusResponseSchema';

export const getUpdateOrderShowDeltaTMutation = (): MutationOptions<
  UpdateShowDeltaTResponse,
  Error,
  { orderId: number; showDeltaT: boolean }
> => ({
  mutationFn: ({ orderId, showDeltaT }) =>
    updateOrderShowDeltaT(orderId, showDeltaT),
});

export const getUpdateOrderMutation = (): MutationOptions<
  UpdateOrderResponse,
  Error,
  { orderId: number; updatedOrder: OrderUpdate }
> => ({
  mutationFn: ({ orderId, updatedOrder }) => updateOrder(orderId, updatedOrder),
});

export const getUpdateOrderStatusMutation = (): MutationOptions<
  ExitStatusResponse,
  Error,
  { orderUuid: string; newStatus: number }
> => ({
  mutationFn: ({ orderUuid, newStatus }) =>
    updateOrderStatus(orderUuid, newStatus),
});
